export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-comment-minus-9915451a36927efcfa383ade7285d186.svg";